import { Controller, useFormContext } from "react-hook-form";
import { FormLabel } from "../FormLabel";
import { FileInput } from "@/components";
import { FormErrorLabel } from "../FormErrorLabel";

const FormFileInput = ({ name, label, error, isRequired, ...rest }: any) => {
  const { control } = useFormContext();
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label}{" "}
          {rest?.disabled ? (
            <></>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <FileInput
              setFile={field.onChange}
              file={field.value}
              {...field}
              {...rest}
            />
          );
        }}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormFileInput;
